import { compact, filter, find, isEmpty, isArray, map } from 'lodash';
import React, { useContext, useMemo } from 'react';
import { OrganisationsFilterContext } from '../../../../common/components/containers/OrganisationsFilterContextProvider';
import { isBusinessEntity } from '../../../../model/OrganisationTypes';
import useOrganisationGroups from '../../../data/hooks/useOrganisationGroups';
import organisationTreeSelector from '../../../data/organisationTreeSelector.graphql';
import nodeSortingOptionsSequence from '../../../utils/nodeSortingOptionsSequence';
import { adapter } from '../../containers/EntityForm/fields/OrganisationsTreeSelectorField';
import useT from '../../utils/Translations/useT';
import GqlStaticTreeSelector from './GqlStaticTreeSelector';
import useResetOnDeps from './hooks/useResetOnDeps';
import { isRootNode } from '../../dataViews/DynamicTree';
import Button from '../Button';
const OrganisationsBeTreeSelector = ({ title = 'Organisations', orgGroupId, orgGroupSelectorName, filter: filterValues, disabled = false, onChange, ...rest }) => {
    const { models: orgGroups } = useOrganisationGroups();
    const t = useT();
    const { selectedOrganisations } = useContext(OrganisationsFilterContext);
    const leafIds = useMemo(() => map(selectedOrganisations, 'id'), [
        selectedOrganisations,
    ]);
    const orgGroupIds = useMemo(() => {
        const ids = orgGroupSelectorName && (filterValues === null || filterValues === void 0 ? void 0 : filterValues[orgGroupSelectorName]);
        return isArray(ids) ? ids : compact([ids !== null && ids !== void 0 ? ids : orgGroupId]);
    }, [filterValues, orgGroupSelectorName, orgGroupId]);
    const orgGroupName = useMemo(() => {
        var _a;
        if (orgGroupIds.length > 1)
            return t('Organisations');
        return (_a = find(orgGroups, { id: orgGroupIds[0] })) === null || _a === void 0 ? void 0 : _a.name;
    }, [orgGroups, orgGroupIds, t]);
    useResetOnDeps({ orgGroupIds }, onChange, []);
    const renderNodeAddons = (node, meta) => {
        const { handleClear } = meta;
        const handleClearFn = e => {
            handleClear();
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
        };
        const addons = [];
        if (isRootNode(node)) {
            addons.push(<Button additionClasses="text-primary no-padding-top no-padding-bottom" buttonStyle="link" onClick={handleClearFn}>
          {t('Clear')}
        </Button>);
        }
        return addons;
    };
    return (<GqlStaticTreeSelector hasSyntheticRootNode adapter={{ ...adapter, renderNodeAddons }} disabled={isEmpty(orgGroupIds) || disabled} gql={organisationTreeSelector} gqlSkip={isEmpty(orgGroupIds)} gqlVariables={{ orgGroupIds, leafIds }} hasClearButton={false} plugins={{
        nodeSortingOptions: nodeSortingOptionsSequence,
    }} selectionFilter={selectionFilter} syntheticRootNodeName={orgGroupName} title={t(title)} onChange={onChange} {...rest}/>);
};
export default OrganisationsBeTreeSelector;
export const selectionFilter = organisations => filter(organisations, isBusinessEntity);
